<template>
<div class="form-switch-item">
  <div class="form-switch-item-label">{{ label }}</div>
  <div class="form-switch-item-input" :title="title">
    <dx-switch
      v-model="localValue"
      :disabled="isLoading || disabled"
      :width="50"
      @value-changed="onValueChanged"
      ref="switch"
    />
    <div v-if="isLoading" class="form-switch-item-loading">
      <dx-load-indicator
        :visible="isLoading"
      />
    </div>
  </div>
</div>
</template>

<script>
import { DxSwitch } from 'devextreme-vue/switch';
import { DxLoadIndicator } from 'devextreme-vue';

export default {
  name: 'form-switch-item',

  props: {
    label: {
      type: String,
      required: true
    },
    itemValue: {
      type: Boolean,
      required: true
    },
    title: {
      type: String,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      localValue: this.itemValue,
    };
  },

  computed: {
  },

  methods: {
    onValueChanged(e) {
      e.component.option('value', this.itemValue); // сброс до значения из props
      if (e.value !== this.itemValue) {
        this.$emit('change', e.value);
      }
    }
  },

  watch: {
    itemValue(newValue) {
      this.localValue = newValue;
      this.$refs.switch.instance.option('value', this.itemValue); // сброс до значения из props
    },
  },

  components: {
    DxSwitch,
    DxLoadIndicator
  },
};
</script>

<style lang="scss">
.form-switch-item {
  display: flex;
  flex-direction: row;
  align-items: center;

  .form-switch-item-label {
    padding-right: 10px;
    font-size: 14px;
    font-weight: 500;
    color: #333;
  }
  
  .form-switch-item-input {
    position: relative;
    height: 35.31px;
    display: flex;
    align-items: center;
  }

  .form-switch-item-loading {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: flex;
    align-items: center;
  }
}
</style>